import IOperaton from '../IOperation'

/**
 * 统计分析
 * 规定数据格式
 * 不做其他处理
 */
export default class IStatistics extends IOperaton {
    /**
     * @description 处理
     * @api
     */
    async _process(fc, ...rest) {}
}
